import { cat_beb_products } from "./beb";
import { cat_car_products } from "./car";
import { cat_gra_products } from "./gra";
import { cat_lac_products } from "./lac";
import { cat_fv_products } from "./fv";
import { cat_pan_products } from "./pan";
import { cat_aseo_products } from "./aseo";
import { cat_snk_products } from "./snk";
import { cat_fast_products } from "./fast";
import { cat_rest_products } from "./rest";
import { cat_desay_products } from "./desayuno";
import { cat_extra_products } from "./extras";
import { cat_vet_products } from "./vet";
import { cat_ropa_products } from "./ropa";
import { cat_calz_products } from "./calz";
import { cat_acc_products } from "./acc";
import { cat_tech_products } from "./tech";
import { cat_hogar_products } from "./hogar";
import { cat_salsa_products } from "./salsa";
import { cat_farm_products } from "./farm";
import { cat_ferr_products } from "./ferr";
import { cat_jug_products } from "./jug";
import { cat_pap_products } from "./pap";
import { cat_dep_products } from "./dep";
import { cat_bell_products } from "./bell";
import { cat_masc_products } from "./masc";
import { cat_joy_products } from "./joy";
import { cat_mue_products } from "./mue";
import { cat_hela_products } from "./hela";
import { cat_pesce_products } from "./pesce";
import { cat_flor_products } from "./flor";
import { cat_serv_products } from "./serv";
import { cat_auto_products } from "./auto";
import { cat_mini_products } from "./mini";
import { cat_elec_products } from "./elec";
import { cat_lib_products } from "./lib";
import type { Producto } from "@/types";

export const all_category_products: Producto[] = [
  ...cat_beb_products,
  ...cat_car_products,
  ...cat_gra_products,
  ...cat_lac_products,
  ...cat_fv_products,
  ...cat_pan_products,
  ...cat_aseo_products,
  ...cat_snk_products,
  ...cat_fast_products,
  ...cat_rest_products,
  ...cat_desay_products,
  ...cat_extra_products,
  ...cat_vet_products,
  ...cat_ropa_products,
  ...cat_calz_products,
  ...cat_acc_products,
  ...cat_tech_products,
  ...cat_hogar_products,
  ...cat_salsa_products,
  ...cat_farm_products,
  ...cat_ferr_products,
  ...cat_jug_products,
  ...cat_pap_products,
  ...cat_dep_products,
  ...cat_bell_products,
  ...cat_masc_products,
  ...cat_joy_products,
  ...cat_mue_products,
  ...cat_hela_products,
  ...cat_pesce_products,
  ...cat_flor_products,
  ...cat_serv_products,
  ...cat_auto_products,
  ...cat_mini_products,
  ...cat_elec_products,
  ...cat_lib_products,
];
